import * as storeTypes from "./storeTypes";
import { IEventList } from "../event/eventList";
import { IEventEdit } from "../event/eventEdit";
import IBeforeInstallPromptEvent = storeTypes.IBeforeInstallPromptEvent;
import { IFrontPage } from "../front/frontPage";
import { IMessageList } from "../message/messageList";
import { IMessageEdit } from "../message/messageEdit";
import { ILoginResult } from "../login/loginResult";
import { IDocumentList } from "../document/documentList";
import { ITaskList } from "../task/taskList";
import { ITaskEdit } from "../task/taskEdit";
import { IUserFurtherEducationList } from "../userFurtherEducation/userFurtherEducationList";
import { IUserFurtherEducationEdit } from "../userFurtherEducation/userFurtherEducationEdit";
import { IInstantMessageChannelItems } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItems";
import { IInstantMessageChannelEdit } from "ui/Scripts/source/models/instantMessage/instantMessageChannelEdit";
import { IDocumentView } from "../document/documentView";
import { IUserIdCardItem } from "../userIdCard/userIdCardItem";
import { IFrontPageInstantMessage } from "../front/frontPageInstantMessage";
import { IFrontPageMessage } from "../front/frontPageMessage";
import { IFrontPageEvent } from "../front/frontPageEvent";
import { IFrontPageTask } from "../front/frontPageTask";
import { IFrontPageDocument } from "../front/frontPageDocument";
import { IFrontPageCalendarTask } from "../front/frontPageCalendarTask";
import { ICalendarTaskEdit } from "ui/Scripts/source/models/calendarTask/calendarTaskEdit";
import { IMobileCalendarTaskItems } from "../calendarTask/mobileCalendarTaskItems";

//Action creators

//Fetch
export const fetchStart = (): storeTypes.IFetchStart => ({
    type: storeTypes.FETCH_START
});

export const fetchEnd = (): storeTypes.IFetchEnd => ({
    type: storeTypes.FETCH_END
});

//Install
export const setInstallProposalEvent = (event: IBeforeInstallPromptEvent): storeTypes.IInstallSet => ({
    type: storeTypes.INSTALL_SET,
    event
});

export const clearInstallProposalEvent = (): storeTypes.IInstallClear => ({
    type: storeTypes.INSTALL_CLEAR
});

//Update
export const setUpdate = (onYes: storeTypes.IConfirmationCallback, onNo: storeTypes.IConfirmationCallback): storeTypes.IUpdateSet => ({
    type: storeTypes.UPDATE_SET,
    onYes,
    onNo
});

export const clearUpdate = (): storeTypes.IUpdateClear => ({
    type: storeTypes.UPDATE_CLEAR
});

//Alert
export const showSuccessMessage = (message: string): storeTypes.IAlertSuccess => ({
    type: storeTypes.ALERT_SUCCESS,
    message
});

export const showInfoMessage = (message: string): storeTypes.IAlertInfo => ({
    type: storeTypes.ALERT_INFO,
    message
});

export const showErrorMessage = (message: string): storeTypes.IAlertError => ({
    type: storeTypes.ALERT_ERROR,
    message
});

export const clearMessages = (): storeTypes.IAlertClear => ({
    type: storeTypes.ALERT_CLEAR
});

export const clearSuccessMessage = (): storeTypes.IAlertSuccessClear => ({
    type: storeTypes.ALERT_SUCCESS_CLEAR
});

export const clearInfoMessage = (): storeTypes.IAlertInfoClear => ({
    type: storeTypes.ALERT_INFO_CLEAR
});

//Confirmation
export const setConfirmation = (type: storeTypes.ConfirmationDialogType, title: string, text: string, onYes: storeTypes.IConfirmationCallback, onNo: storeTypes.IConfirmationCallback, onCancel: storeTypes.IConfirmationCallback = null): storeTypes.IConfirmationSet => ({
    type: storeTypes.CONFIRMATION_SET,
    dialogType: type,
    title,
    text,
    show: true,
    onYes,
    onNo,
    onCancel
});

export const clearConfirmation = (): storeTypes.IConfirmationClear => ({
    type: storeTypes.CONFIRMATION_CLEAR
});

//Token
export const loginSuccess = (loginResult: ILoginResult): storeTypes.ILoginSuccess => ({
    type: storeTypes.LOGIN_SUCCESS,
    companyId: loginResult.companyId,
    companyName: loginResult.companyName,
    userCode: loginResult.code,
    userName: loginResult.name,
    userPicture: loginResult.picture,
    canUseMessages: loginResult.canUseMessages,
    canUseDocuments: loginResult.canUseDocuments,
    canUseEvents: loginResult.canUseEvents,
    canUseTasks: loginResult.canUseTasks,
    canUseInstantMessages: loginResult.canUseInstantMessages,
    canEditOwnRecord: loginResult.canEditOwnRecord,
    canUseCalendarTasks: loginResult.canUseCalendarTasks,
    canUseMultipleCompanies: loginResult.canUseMultipleCompanies,
});

export const loginFailure = (): storeTypes.ILoginFailure => ({
    type: storeTypes.LOGIN_FAILURE
});

export const logoutSuccess = (): storeTypes.ILogoutSuccess => ({
    type: storeTypes.LOGOUT_SUCCESS
});

//Front
export const frontPageRequest = (): storeTypes.IFrontPageRequest => ({
    type: storeTypes.FRONT_PAGE_REQUEST,
});

export const frontPageSuccess = (frontPage: IFrontPage): storeTypes.IFrontPageSuccess => ({
    type: storeTypes.FRONT_PAGE_SUCCESS,
    frontPage
});

export const frontPageFailure = (): storeTypes.IFrontPageFailure => ({
    type: storeTypes.FRONT_PAGE_FAILURE
});

//Front: Message
export const frontPageMessageRequest = (): storeTypes.IFrontPageMessageRequest => ({
    type: storeTypes.FRONT_PAGE_MESSAGE_REQUEST,
});

export const frontPageMessageSuccess = (frontPageMessage: IFrontPageMessage): storeTypes.IFrontPageMessageSuccess => ({
    type: storeTypes.FRONT_PAGE_MESSAGE_SUCCESS,
    frontPageMessage
});

export const frontPageMessageFailure = (): storeTypes.IFrontPageMessageFailure => ({
    type: storeTypes.FRONT_PAGE_MESSAGE_FAILURE
});

//Front: Event
export const frontPageEventRequest = (): storeTypes.IFrontPageEventRequest => ({
    type: storeTypes.FRONT_PAGE_EVENT_REQUEST,
});

export const frontPageEventSuccess = (frontPageEvent: IFrontPageEvent): storeTypes.IFrontPageEventSuccess => ({
    type: storeTypes.FRONT_PAGE_EVENT_SUCCESS,
    frontPageEvent
});

export const frontPageEventFailure = (): storeTypes.IFrontPageEventFailure => ({
    type: storeTypes.FRONT_PAGE_EVENT_FAILURE
});

//Front: Task
export const frontPageTaskRequest = (): storeTypes.IFrontPageTaskRequest => ({
    type: storeTypes.FRONT_PAGE_TASK_REQUEST,
});

export const frontPageTaskSuccess = (frontPageTask: IFrontPageTask): storeTypes.IFrontPageTaskSuccess => ({
    type: storeTypes.FRONT_PAGE_TASK_SUCCESS,
    frontPageTask
});

export const frontPageTaskFailure = (): storeTypes.IFrontPageTaskFailure => ({
    type: storeTypes.FRONT_PAGE_TASK_FAILURE
});

//Front: Document
export const frontPageDocumentRequest = (): storeTypes.IFrontPageDocumentRequest => ({
    type: storeTypes.FRONT_PAGE_DOCUMENT_REQUEST,
});

export const frontPageDocumentSuccess = (frontPageDocument: IFrontPageDocument): storeTypes.IFrontPageDocumentSuccess => ({
    type: storeTypes.FRONT_PAGE_DOCUMENT_SUCCESS,
    frontPageDocument
});

export const frontPageDocumentFailure = (): storeTypes.IFrontPageDocumentFailure => ({
    type: storeTypes.FRONT_PAGE_DOCUMENT_FAILURE
});

//Front: InstantMessage
export const frontPageInstantMessageRequest = (): storeTypes.IFrontPageInstantMessageRequest => ({
    type: storeTypes.FRONT_PAGE_INSTANTMESSAGE_REQUEST,
});

export const frontPageInstantMessageSuccess = (frontPageInstantMessage: IFrontPageInstantMessage): storeTypes.IFrontPageInstantMessageSuccess => ({
    type: storeTypes.FRONT_PAGE_INSTANTMESSAGE_SUCCESS,
    frontPageInstantMessage
});

export const frontPageInstantMessageFailure = (): storeTypes.IFrontPageInstantMessageFailure => ({
    type: storeTypes.FRONT_PAGE_INSTANTMESSAGE_FAILURE
});

//Front: CalendarTask
export const frontPageCalendarTaskRequest = (): storeTypes.IFrontPageCalendarTaskRequest => ({
    type: storeTypes.FRONT_PAGE_CALENDARTASK_REQUEST,
});

export const frontPageCalendarTaskSuccess = (frontPageCalendarTask: IFrontPageCalendarTask): storeTypes.IFrontPageCalendarTaskSuccess => ({
    type: storeTypes.FRONT_PAGE_CALENDARTASK_SUCCESS,
    frontPageCalendarTask
});

export const frontPageCalendarTaskFailure = (): storeTypes.IFrontPageCalendarTaskFailure => ({
    type: storeTypes.FRONT_PAGE_CALENDARTASK_FAILURE
});

//Message
export const messageListRequest = (): storeTypes.IMessageListRequest => ({
    type: storeTypes.MESSAGE_LIST_REQUEST,
});

export const messageListSuccess = (messageList: IMessageList, startDate: number, endDate: number, companyId: string): storeTypes.IMessageListSuccess => ({
    type: storeTypes.MESSAGE_LIST_SUCCESS,
    messageList,
    startDate,
    endDate,
    companyId
});

export const messageListRefresh = (messageList: IMessageList, startDate: number, endDate: number, companyId: string): storeTypes.IMessageListRefresh => ({
    type: storeTypes.MESSAGE_LIST_REFRESH,
    messageList,
    startDate,
    endDate,
    companyId
});

export const messageListFailure = (): storeTypes.IMessageListFailure => ({
    type: storeTypes.MESSAGE_LIST_FAILURE
});

export const messageListReset = (): storeTypes.IMessageListReset => ({
    type: storeTypes.MESSAGE_LIST_RESET
});

export const messageListSetLastOpened = (id: string): storeTypes.IMessageListSetLastOpened => ({
    type: storeTypes.MESSAGE_LIST_SETLASTOPENED,
    messageId: id,
});

export const messageEditRequest = (): storeTypes.IMessageEditRequest => ({
    type: storeTypes.MESSAGE_EDIT_REQUEST,
});

export const messageEditSuccess = (messageEdit: IMessageEdit): storeTypes.IMessageEditSuccess => ({
    type: storeTypes.MESSAGE_EDIT_SUCCESS,
    messageEdit
});

export const messageEditFailure = (): storeTypes.IMessageEditFailure => ({
    type: storeTypes.MESSAGE_EDIT_FAILURE
});

export const messageEditReset = (): storeTypes.IMessageEditReset => ({
    type: storeTypes.MESSAGE_EDIT_RESET
});

export const messageEditSetReturnUrl = (returnUrl: string): storeTypes.IMessageEditSetReturnUrl => ({
    type: storeTypes.MESSAGE_EDIT_SETRETURNURL,
    returnUrl
});

//Event
export const eventListRequest = (): storeTypes.IEventListRequest => ({
    type: storeTypes.EVENT_LIST_REQUEST,
});

export const eventListSuccess = (eventList: IEventList, state: number, startDate: number, endDate: number, unitId: string): storeTypes.IEventListSuccess => ({
    type: storeTypes.EVENT_LIST_SUCCESS,
    eventList,
    state,
    startDate,
    endDate,
    unitId
});

export const eventListRefresh = (eventList: IEventList, state: number, startDate: number, endDate: number, unitId: string): storeTypes.IEventListRefresh => ({
    type: storeTypes.EVENT_LIST_REFRESH,
    eventList,
    state,
    startDate,
    endDate,
    unitId
});

export const eventListFailure = (): storeTypes.IEventListFailure => ({
    type: storeTypes.EVENT_LIST_FAILURE
});

export const eventListRemove = (id: string): storeTypes.IEventListRemove => ({
    type: storeTypes.EVENT_LIST_REMOVE,
    eventId: id
});

export const eventListReset = (): storeTypes.IEventListReset => ({
    type: storeTypes.EVENT_LIST_RESET
});

export const eventListSetLastOpened = (id: string): storeTypes.IEventListSetLastOpened => ({
    type: storeTypes.EVENT_LIST_SETLASTOPENED,
    eventId: id,
});

export const eventListSetLocked = (id: string, locked: boolean): storeTypes.IEventListSetLocked => ({
    type: storeTypes.EVENT_LIST_SETLOCKED,
    eventId: id,
    locked
});

export const eventEditRequest = (): storeTypes.IEventEditRequest => ({
    type: storeTypes.EVENT_EDIT_REQUEST,
});

export const eventEditSuccess = (eventEdit: IEventEdit): storeTypes.IEventEditSuccess => ({
    type: storeTypes.EVENT_EDIT_SUCCESS,
    eventEdit
});

export const eventEditFailure = (): storeTypes.IEventEditFailure => ({
    type: storeTypes.EVENT_EDIT_FAILURE
});

export const eventEditReset = (): storeTypes.IEventEditReset => ({
    type: storeTypes.EVENT_EDIT_RESET
});

export const eventEditSetReturnUrl = (returnUrl: string): storeTypes.IEventEditSetReturnUrl => ({
    type: storeTypes.EVENT_EDIT_SETRETURNURL,
    returnUrl
});

//Task
export const taskListRequest = (): storeTypes.ITaskListRequest => ({
    type: storeTypes.TASK_LIST_REQUEST,
});

export const taskListSuccess = (taskList: ITaskList, stateId: string, unitId: string): storeTypes.ITaskListSuccess => ({
    type: storeTypes.TASK_LIST_SUCCESS,
    taskList,
    stateId,
    unitId
});

export const taskListRefresh = (taskList: ITaskList, stateId: string, unitId: string): storeTypes.ITaskListRefresh => ({
    type: storeTypes.TASK_LIST_REFRESH,
    taskList,
    stateId,
    unitId
});

export const taskListFailure = (): storeTypes.ITaskListFailure => ({
    type: storeTypes.TASK_LIST_FAILURE
});

export const taskListRemove = (id: string): storeTypes.ITaskListRemove => ({
    type: storeTypes.TASK_LIST_REMOVE,
    taskId: id
});

export const taskListReset = (): storeTypes.ITaskListReset => ({
    type: storeTypes.TASK_LIST_RESET
});

export const taskListSetLastOpened = (id: string): storeTypes.ITaskListSetLastOpened => ({
    type: storeTypes.TASK_LIST_SETLASTOPENED,
    taskId: id,
});

export const taskListSetLocked = (id: string, locked: boolean): storeTypes.ITaskListSetLocked => ({
    type: storeTypes.TASK_LIST_SETLOCKED,
    taskId: id,
    locked
});

export const taskEditRequest = (): storeTypes.ITaskEditRequest => ({
    type: storeTypes.TASK_EDIT_REQUEST,
});

export const taskEditSuccess = (taskEdit: ITaskEdit): storeTypes.ITaskEditSuccess => ({
    type: storeTypes.TASK_EDIT_SUCCESS,
    taskEdit
});

export const taskEditFailure = (): storeTypes.ITaskEditFailure => ({
    type: storeTypes.TASK_EDIT_FAILURE
});

export const taskEditReset = (): storeTypes.ITaskEditReset => ({
    type: storeTypes.TASK_EDIT_RESET
});

export const taskEditSetReturnUrl = (returnUrl: string): storeTypes.ITaskEditSetReturnUrl => ({
    type: storeTypes.TASK_EDIT_SETRETURNURL,
    returnUrl
});

//Document
export const documentListRequest = (): storeTypes.IDocumentListRequest => ({
    type: storeTypes.DOCUMENT_LIST_REQUEST,
});

export const documentListSuccess = (documentList: IDocumentList, filter: string): storeTypes.IDocumentListSuccess => ({
    type: storeTypes.DOCUMENT_LIST_SUCCESS,
    documentList,
    filter
});

export const documentListFailure = (): storeTypes.IDocumentListFailure => ({
    type: storeTypes.DOCUMENT_LIST_FAILURE
});

export const documentListSetLastOpened = (id: string): storeTypes.IDocumentListSetLastOpened => ({
    type: storeTypes.DOCUMENT_LIST_SETLASTOPENED,
    documentId: id
});

export const documentListReset = (): storeTypes.IDocumentListReset => ({
    type: storeTypes.DOCUMENT_LIST_RESET
});

export const documentListAddFavorite = (id: string): storeTypes.IDocumentListAddFavorite => ({
    type: storeTypes.DOCUMENT_LIST_ADD_FAVORITE,
    folderId: id
});

export const documentListRemoveFavorite = (id: string): storeTypes.IDocumentListRemoveFavorite => ({
    type: storeTypes.DOCUMENT_LIST_REMOVE_FAVORITE,
    folderId: id
});

export const documentViewRequest = (): storeTypes.IDocumentViewRequest => ({
    type: storeTypes.DOCUMENT_VIEW_REQUEST,
});

export const documentViewSuccess = (documentView: IDocumentView): storeTypes.IDocumentViewSuccess => ({
    type: storeTypes.DOCUMENT_VIEW_SUCCESS,
    documentView
});

export const documentViewFailure = (): storeTypes.IDocumentViewFailure => ({
    type: storeTypes.DOCUMENT_VIEW_FAILURE
});

export const documentViewReset = (): storeTypes.IDocumentViewReset => ({
    type: storeTypes.DOCUMENT_VIEW_RESET
});

export const documentViewSetReturnUrl = (returnUrl: string): storeTypes.IDocumentViewSetReturnUrl => ({
    type: storeTypes.DOCUMENT_VIEW_SETRETURNURL,
    returnUrl
});

//UserFurtherEducation
export const userFurtherEducationListRequest = (): storeTypes.IUserFurtherEducationListRequest => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_REQUEST,
});

export const userFurtherEducationListSuccess = (list: IUserFurtherEducationList, archived: boolean): storeTypes.IUserFurtherEducationListSuccess => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_SUCCESS,
    list,
    archived
});

export const userFurtherEducationListRefresh = (list: IUserFurtherEducationList, archived: boolean): storeTypes.IUserFurtherEducationListRefresh => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_REFRESH,
    list,
    archived
});

export const userFurtherEducationListFailure = (): storeTypes.IUserFurtherEducationListFailure => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_FAILURE
});

export const userFurtherEducationListRemove = (id: string): storeTypes.IUserFurtherEducationListRemove => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_REMOVE,
    userFurtherEducationId: id
});

export const userFurtherEducationListReset = (): storeTypes.IUserFurtherEducationListReset => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_RESET
});

export const userFurtherEducationListSetLastOpened = (id: string): storeTypes.IUserFurtherEducationListSetLastOpened => ({
    type: storeTypes.USERFURTHEREDUCATION_LIST_SETLASTOPENED,
    userFurtherEducationId: id,
});

export const userFurtherEducationEditRequest = (): storeTypes.IUserFurtherEducationEditRequest => ({
    type: storeTypes.USERFURTHEREDUCATION_EDIT_REQUEST,
});

export const userFurtherEducationEditSuccess = (userFurtherEducationEdit: IUserFurtherEducationEdit): storeTypes.IUserFurtherEducationEditSuccess => ({
    type: storeTypes.USERFURTHEREDUCATION_EDIT_SUCCESS,
    userFurtherEducationEdit
});

export const userFurtherEducationEditFailure = (): storeTypes.IUserFurtherEducationEditFailure => ({
    type: storeTypes.USERFURTHEREDUCATION_EDIT_FAILURE
});

export const userFurtherEducationEditReset = (): storeTypes.IUserFurtherEducationEditReset => ({
    type: storeTypes.USERFURTHEREDUCATION_EDIT_RESET
});

export const userFurtherEducationEditSetReturnUrl = (returnUrl: string): storeTypes.IUserFurtherEducationEditSetReturnUrl => ({
    type: storeTypes.USERFURTHEREDUCATION_EDIT_SETRETURNURL,
    returnUrl
});

//InstantMessage

//instantMessageChannelList
export const instantMessageChannelListRequest = (): storeTypes.IInstantMessageChannelListRequest => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_LIST_REQUEST,
});

export const instantMessageChannelListSuccess = (list: IInstantMessageChannelItems): storeTypes.IInstantMessageChannelListSuccess => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_LIST_SUCCESS,
    list
});

export const instantMessageChannelListFailure = (): storeTypes.IInstantMessageChannelListFailure => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_LIST_FAILURE
});

export const instantMessageChannelListRemove = (id: string): storeTypes.IInstantMessageChannelListRemove => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_LIST_REMOVE,
    instantMessageChannelId: id
});

export const instantMessageChannelListReset = (): storeTypes.IInstantMessageChannelListReset => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_LIST_RESET
});

export const instantMessageChannelListSetLastOpened = (id: string): storeTypes.IInstantMessageChannelListSetLastOpened => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_LIST_SETLASTOPENED,
    instantMessageChannelId: id,
});

//instantMessageChannelEdit
export const instantMessageChannelEditRequest = (): storeTypes.IInstantMessageChannelEditRequest => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_EDIT_REQUEST,
});

export const instantMessageChannelEditSuccess = (item: IInstantMessageChannelEdit): storeTypes.IInstantMessageChannelEditSuccess => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_EDIT_SUCCESS,
    item
});

export const instantMessageChannelEditFailure = (): storeTypes.IInstantMessageChannelEditFailure => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_EDIT_FAILURE
});

export const instantMessageChannelEditReset = (): storeTypes.IInstantMessageChannelEditReset => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_EDIT_RESET
});

export const instantMessageChannelEditSetReturnUrl = (returnUrl: string): storeTypes.IInstantMessageChannelEditSetReturnUrl => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_EDIT_SETRETURNURL,
    returnUrl
});

//instantMessageChannelOpen
export const instantMessageChannelOpenSetReturnUrl = (returnUrl: string): storeTypes.IInstantMessageChannelOpenSetReturnUrl => ({
    type: storeTypes.INSTANTMESSAGECHANNEL_OPEN_SETRETURNURL,
    returnUrl
});

//CalendarTask

//CalendarTaskView
export const calendarTaskViewRequest = (): storeTypes.ICalendarTaskViewRequest => ({
    type: storeTypes.CALENDARTASK_VIEW_REQUEST,
});

export const calendarTaskViewSuccess = (items: IMobileCalendarTaskItems, filter: string, stateId: string, categoryId: string): storeTypes.ICalendarTaskViewSuccess => ({
    type: storeTypes.CALENDARTASK_VIEW_SUCCESS,
    items,
    filter,
    stateId,
    categoryId
});

export const calendarTaskViewFailure = (): storeTypes.ICalendarTaskViewFailure => ({
    type: storeTypes.CALENDARTASK_VIEW_FAILURE
});

export const calendarTaskViewRemove = (id: string): storeTypes.ICalendarTaskViewRemove => ({
    type: storeTypes.CALENDARTASK_VIEW_REMOVE,
    calendarTaskId: id
});

export const calendarTaskViewReset = (): storeTypes.ICalendarTaskViewReset => ({
    type: storeTypes.CALENDARTASK_VIEW_RESET
});

export const calendarTaskViewSetLastOpened = (id: string): storeTypes.ICalendarTaskViewSetLastOpened => ({
    type: storeTypes.CALENDARTASK_VIEW_SETLASTOPENED,
    calendarTaskId: id,
});

export const calendarTaskViewSetLocked = (id: string, locked: boolean): storeTypes.ICalendarTaskViewSetLocked => ({
    type: storeTypes.CALENDARTASK_VIEW_SETLOCKED,
    calendarTaskId: id,
    locked
});

//CalendarTaskEdit
export const calendarTaskEditRequest = (): storeTypes.ICalendarTaskEditRequest => ({
    type: storeTypes.CALENDARTASK_EDIT_REQUEST,
});

export const calendarTaskEditSuccess = (item: ICalendarTaskEdit): storeTypes.ICalendarTaskEditSuccess => ({
    type: storeTypes.CALENDARTASK_EDIT_SUCCESS,
    item
});

export const calendarTaskEditFailure = (): storeTypes.ICalendarTaskEditFailure => ({
    type: storeTypes.CALENDARTASK_EDIT_FAILURE
});

export const calendarTaskEditReset = (): storeTypes.ICalendarTaskEditReset => ({
    type: storeTypes.CALENDARTASK_EDIT_RESET
});

export const calendarTaskEditSetReturnUrl = (returnUrl: string): storeTypes.ICalendarTaskEditSetReturnUrl => ({
    type: storeTypes.CALENDARTASK_EDIT_SETRETURNURL,
    returnUrl
});

//IdCardView
export const idCardViewRequest = (): storeTypes.IIdCardViewRequest => ({
    type: storeTypes.IDCARD_VIEW_REQUEST,
});

export const idCardViewSuccess = (item: IUserIdCardItem): storeTypes.IIdCardViewSuccess => ({
    type: storeTypes.IDCARD_VIEW_SUCCESS,
    item
});

export const idCardViewFailure = (): storeTypes.IIdCardViewFailure => ({
    type: storeTypes.IDCARD_VIEW_FAILURE
});
